import { ICategory, ICategoryProviderGames, IGame, IGameCategory, IGameProvider } from '@libs/interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IFilters, ISearch } from './model';

const selectSearcherFeat = createFeatureSelector<Readonly<ISearch>>('searcher');
export const selectSearcherList = createSelector(selectSearcherFeat, (state: ISearch): IGame[] => state.list);
export const selectSearcherWord = createSelector(selectSearcherFeat, (state: ISearch): string => state.filters.word);
export const selectSearcherShow = createSelector(selectSearcherFeat, (state: ISearch): boolean => state.show);
export const selectSearcherLoading = createSelector(selectSearcherFeat, (state: ISearch): boolean => state.loading);
export const selectFiltersWord = createSelector(selectSearcherFeat, (state: ISearch): string => state.filters.word);
export const selectFiltersProvider = createSelector(
  selectSearcherFeat,
  (state: ISearch): IGameProvider => state.filters.provider,
);
export const selectFiltersCategory = createSelector(
  selectSearcherFeat,
  (state: ISearch): ICategory => state.filters.category,
);
export const selectFilters = createSelector(selectSearcherFeat, (state: ISearch): IFilters => state.filters);
export const selectEndlessGames = createSelector(selectSearcherFeat, (state: ISearch): IGame[] => state.endlessGames);
export const selectTree = createSelector(selectSearcherFeat, (state: ISearch): ICategoryProviderGames[] => state.tree);
// export const selectDevice = createSelector(selectSearcherFeat, (state: ISearch): string => state.filters.device);
export const selectSearcherGamesCategories = createSelector(
  selectSearcherFeat,
  (state: ISearch): IGameCategory[] => state.categories,
);
